module.exports = __webpack_public_path__ + "static/img/marker-icon-blue-full.a5818fe6.png";